import { useQuery, useMutation } from '@apollo/client';
import { GET_USER_SWAPS_DELIVERY_DAY, LIST_UNLOCKED_AVAILABLE_DELIVERY_DAYS } from 'core/api/apollo/queries';
import { DESTROY_USER_MEAL_SWAP_REQUEST } from 'core/api/apollo/mutations';

export const useOrderData = () => {
  const { data: { listUnlockedAvailableDeliveryDays = [] } = {} } = useQuery(
    LIST_UNLOCKED_AVAILABLE_DELIVERY_DAYS
  );

  const deliveryDays = listUnlockedAvailableDeliveryDays.filter(
    (day) => !day.locked && day.menuPublished
  );
  const deliveryDayIds = deliveryDays.map((day) => day.id);

  const variables = { deliveryDayIds: deliveryDayIds.toString() };

  const {
    loading,
    error,
    data: { getUserSwapsForDeliveryDay = [] } = {},
    refetch,
  } = useQuery(GET_USER_SWAPS_DELIVERY_DAY, {
    variables,
    skip: deliveryDayIds.length === 0,
    fetchPolicy: 'network-only',
  });

  const [destroyUserMealSwapRequest] = useMutation(DESTROY_USER_MEAL_SWAP_REQUEST, {
    onCompleted: (data) => {
      refetch();
      // eslint-disable-next-line no-console
      console.log('Swap request deleted successfully', data);
    },
    onError: (error) => {
      console.error('Error deleting swap request', error);
    },
  });

  const handleDeleteSwapRequest = async (ids) => {
    try {
      await destroyUserMealSwapRequest({
        variables: {
          input: {
            ids: ids,
          },
        },
      });
      await refetch();
    } catch (error) {
      console.error('Error deleting swap request:', error);
    }
  };

  return {
    loading,
    error,
    refetchOrders: refetch,
    deliveryDays,
    deliveryDayIds,
    getUserSwapsForDeliveryDay,
    handleDeleteSwapRequest,
  };
};
